exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_groupEditPanel_54c_J3DEZPPV3Gvuox5ss {\n  position: relative;\n  width: 100%;\n  float: left;\n}\n\n.IA_content_e_826M2NvJQhPyESr1p4U {\n  position: relative;\n  float: left;\n  width: calc(100% - 40px);\n  height: 100%;\n  padding-left: 40px;\n  box-sizing: border-box;\n}", ""]);

// Exports
exports.locals = {
	"IA_groupEditPanel": "IA_groupEditPanel_54c_J3DEZPPV3Gvuox5ss",
	"IA_content": "IA_content_e_826M2NvJQhPyESr1p4U"
};